import { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export function UserContextProvider ({ children }) {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));

    return <UserContext.Provider value={{
        user,
        setUser
    }}>
        {children}
    </UserContext.Provider>
}

export function useUser() {
    return useContext(UserContext);
}